import Vue from 'vue';
import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { StatService } from '@mailer/services/StatService';

export const general = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => StatService.getGeneral(params).catch((e) => Vue.noty.server_error(e))
    }
  },
  true
);
